module.exports = __webpack_public_path__ + "annualreview2018/static/img/people.e26ba0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/covers/people.png
// module id = fMAz
// module chunks = 10